module.exports = __webpack_public_path__ + "img/step_04.e560abb2.png";